import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fury-simplificationcorporate',
  templateUrl: './simplificationcorporate.component.html',
  styleUrls: ['./simplificationcorporate.component.scss']
})
export class SimplificationcorporateComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
